import {
    EntityListData,
} from '@/types/entities'

export const DEFAULT_ENTITIES_DATA: EntityListData = {
    Accounts: [],
    Campaigns: [],
    DIDs: [],
    AutomaticCampaigns: [],
    Extension: [],
    Layers: [],
    Queues: [],
    DefaultAccountBreak: [],
    Users: [],
    IVRCampaigns: [],
    UserRecords: [],
    VoiceBots: [],
    AiCategories: [],
}
